import { createCanBoundTo } from '@casl/react';

import { ability } from '@ciao/shared';

const WBCan: React.ReactNode = createCanBoundTo(ability);

export { WBCan };
